import React from 'react'
import { normalizeImageUrl } from '../utils/urlSanitizer'
import { Link } from 'react-router-dom'
import { Card } from 'react-bootstrap'
import Rating from './Rating'

const Product = ({ product }) => {
  const price = Number(product.price || 0).toFixed(2);
  const displayName = product.name;
  return (
    <Card className='product-card my-2'>
      <Link to={`/product/${product.slug || product._id}`} className='product-card__image-link'>
        <div className='product-card__imgwrap'>
          <img
            src={normalizeImageUrl(product.image)}
            alt={displayName}
            loading='lazy'
            className='product-card__img'
          />
        </div>
      </Link>
      <Card.Body className='product-card__body compact'>
        <Link to={`/product/${product.slug || product._id}`} className='text-decoration-none product-card__title-link' title={displayName}>
          <h3 className='product-title'>{displayName}</h3>
        </Link>
        <div className='rating-row'>
          <Rating value={product.rating} text={`${product.numReviews} reviews`} />
        </div>
        <div className='price-row'>${price}</div>
      </Card.Body>
    </Card>
  );
}

export default Product
